import { Center } from '@chakra-ui/react';
import { BrandLoader } from 'app/components/Core';

export const LoadingState = () => (
  <Center height="100%" data-testid="global-search-loader">
    <BrandLoader />
  </Center>
);
